module.exports = __webpack_public_path__ + "img/stop_btn.7c13d91b.png";